/**
 * FinnishFlag.tsx
 * ---------------
 * SVG component for the Finnish flag.
 * - Used in header and footer.
 */


import React from 'react';

const FinnishFlag: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 60 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={40}
    aria-label="Finnish flag"
  >
    <rect width="60" height="40" rx="4" fill="#fff" />
    <rect x="24" width="8" height="40" fill="#0072CE" />
    <rect y="16" width="60" height="8" fill="#0072CE" />
    <rect width="60" height="40" rx="4" fill="none" stroke="#E6EEF1" strokeWidth="2" />
  </svg>
);

export default FinnishFlag;
